module.exports = __webpack_public_path__ + "static/media/news-01.80e47ee4.jpg";